import axios from "axios";
import Vue from "vue";

axios.interceptors.request.use(function (config) {});

axios.interceptors.response.use(undefined, (error) => {
  return error;
});
const apiKey = [
  {
    brand_code: "CRM8FR5HTC1LJ9Y",
    apiKey: "kq9O94iOwEksDJsJ01wNUpU0Imkexh3m",
    apiRoute: "https://api-crm-service-dev.d-dots.com/api/",
  },
  {
    brand_code: "BS9MTR4KPL7XJ2C",
    apiKey: "N4tV7pQ2xK9mL5RzJ3cH8Wb6F1sDgYqT",
    apiRoute: "https://api-support-service-prod.d-dots.com/api/",
  },
];
function getBrandConfig() {
  const params = new URLSearchParams(window.location.search);
  const brandCode = params.get("brand_code");

  if (!brandCode) return null;

  return apiKey.find((item) => item.brand_code === brandCode);
}
const brandConfig = getBrandConfig();
const instance = axios.create({
  baseURL: brandConfig?.apiRoute || process.env.VUE_APP_API,
  responseType: "json",
});

instance.interceptors.request.use(function (config) {
  config.headers["API-KEY"] =
    brandConfig?.apiKey || process.env.VUE_APP_API_KEY;
  return config;
});

Vue.prototype.$Axios = axios;
Vue.prototype.axios = instance;

export { instance, axios };
